var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 240 l0 -240 240 0 240 0 0 240 0 240 -240 0 -240 0 0 -240z m328 179 c51 -25 110 -105 91 -123 -8 -8 -14 -5 -23 8 -62 103 -153 133 -242 81 -48 -28 -84 -91 -84 -147 0 -93 89 -174 183 -165 56 5 92 28 126 80 13 20 30 37 38 37 18 0 17 -6 -9 -51 -50 -89 -169 -124 -258 -77 -25 14 -58 44 -75 67 -26 37 -30 51 -30 111 0 60 4 74 30 111 59 83 163 111 253 68z m-65 -106 c13 -21 39 -64 56 -95 29 -52 31 -58 14 -58 -12 0 -29 20 -51 60 -18 33 -36 62 -40 64 -4 2 -23 -24 -42 -60 -24 -43 -41 -64 -53 -64 -16 0 -14 9 19 67 59 106 69 123 71 123 2 0 13 -17 26 -37z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/LogoLight.403f2eb6.svg";
export { ForwardRef as ReactComponent };